import { execWithCacheAsync } from "../Utils";
import apiClient from "./ApiClient"

export enum EventCheckMode {
    Scan,
    Count
}

export enum GateDirection {
    In = 0x1,
    Out = 0x2,
    Both = In | Out
}


export interface IStoreGate {
    code: string;
    name: string;
    direction?: GateDirection;
}

export interface IStoreEvent {
    id: string;
    title: string;
    date: Date;
    gates: IStoreGate[];
    checkMode?: EventCheckMode; 
}


class EventStore {

    protected _events: { [id: string]: IStoreEvent } = {};

    async listEventsAsync() {

        const events = await execWithCacheAsync("eventList", () => apiClient.getActiveEventsAsync());

        const result = events.map(a => ({
            id: a.idEvento,
            date: new Date(
                parseInt(a.dataEvento.substr(0, 4)),
                parseInt(a.dataEvento.substr(5, 2)) -1, 
                parseInt(a.dataEvento.substr(8, 2)),
                parseInt(a.oraEvento.substr(0, 2)),
                parseInt(a.oraEvento.substr(3, 2))
            ),
            title: a.titoloEvento,
            gates: null,
            checkMode: a.checkMode == "COUNT" ? EventCheckMode.Count : EventCheckMode.Scan
        } as IStoreEvent));

        result.forEach(a => this._events[a.id] = a);

        return result;
    }

    async getEventByIdAsync(id: string) {

        if (!(id in this._events)) 
            await this.listEventsAsync();

        return this._events[id];
    }

    async updateEventGatesAsync(id: string) {

        const event = await this.getEventByIdAsync(id);
        if (!event.gates) {
            try {
                const gates = await execWithCacheAsync("gates-" + id, () => apiClient.getEventGatesAsync(id), []);
                if (gates.length > 0) {
                    event.gates = gates.map(a => ({
                        code: a.gate_code,
                        name: a.gate_name
                    }));
                }
  
            }
            catch (ex) {
                console.warn("updateEventGatesAsync", ex);
            }
        }

        if (!event.gates || event.gates.length == 0)
            event.gates = [{
                code: "0",
                name: "Varco Unico"
            }];

        return event.gates;
    } 

    async getEventGateAsync(eventId: string, gateCode: string) {
        const gates = await this.updateEventGatesAsync(eventId);
        return gates?.find(a => a.code == gateCode);
    }
}


export var eventStore = new EventStore();